/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ArrowLeftShadyIcon = ({ size, ...props }) => (React.createElement("svg", { viewBox: "0 0 29 48", fill: "currentColor", width: size || '1em', height: size || '1em', ...props },
    React.createElement("defs", null,
        React.createElement("filter", { id: "shadow", x: "-10%", y: "-10%", width: "120%", height: "120%" },
            React.createElement("feOffset", { result: "offOut", in: "SourceAlpha" }),
            React.createElement("feGaussianBlur", { result: "blurOut", in: "offOut", stdDeviation: "2" }),
            React.createElement("feBlend", { in: "SourceGraphic", in2: "blurOut" })),
        React.createElement("path", { id: "arrow-left-path", d: "M7.771 33.77l27.598.079v1.917l-27.597-.08v.006h-2.07L5.697 6.155h2.069L7.77 33.77z", strokeWidth: "1" })),
    React.createElement("use", { stroke: "currentColor", fill: "currentColor", transform: "rotate(45 18.533 25.788)", filter: "url(#shadow)", fillRule: "evenodd", xlinkHref: "#arrow-left-path" }),
    React.createElement("use", { fill: "currentColor", stroke: "currentColor", transform: "rotate(45 18.533 25.788)", fillRule: "evenodd", xlinkHref: "#arrow-left-path" })));
ArrowLeftShadyIcon.displayName = 'ArrowLeftShadyIcon';
export default ArrowLeftShadyIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ArrowLeftShadyIcon.js.map